import React from "react";
import {
  getCustomHeadingsLabel,
  headingsMap,
  translateHeading
} from "./../../_shared/headings-dropdown-utils.js";
const getCurrentHeadingIcon = (allowHeadingCustomization) => (publicCommands, t) => {
  const selectedHeading = publicCommands.getCurrentHeading();
  return () => /* @__PURE__ */ React.createElement("div", null, allowHeadingCustomization ? getCustomHeadingsLabel(selectedHeading, t, publicCommands) : translateHeading(headingsMap[selectedHeading], t));
};
export {
  getCurrentHeadingIcon
};
//# sourceMappingURL=get-current-headings-icon.js.map
